<template>
	<div class="wallet-container">
		<div v-if="loading" class="fullscreen-loading">
            <v-progress-circular color="blue" indeterminate="indeterminate"></v-progress-circular>
        </div>
		<!-- <div class="wallet-header"></div> -->
		<div class="wallet-content">
			<!-- <div class="wallet-title">
				<h4>Conta Consigmais</h4>
			</div> -->
			<div class="wallet-user">
				<div class="user-balance">
					<div class="user-balance-content">
						<h4>Saldo</h4>
						<p class="user-balance-value">{{ balance | fmtMoney }}</p>
						<p class="user-today-balance-value">+ {{ todayBalance | fmtMoney }} hoje</p>
					</div>
					<div class="user-balance-buttons">
						<button class="button user-balance" v-on:click="disclamerWithDraw">
							<i class="fas fa-money-bill-wave"></i>
							<p>Sacar</p>
						</button>
					</div>
				</div>
			</div>
			<div class="transactions-container">
				<div class="transactions" v-if="transactions.length">
					<h4>Transações</h4>
					<div class="transaction-list">
						<div class="transaction-content" v-bind:key="transaction.id" v-for="(transaction, index) in transactions">
							<p class="transaction-year" v-if="index > 0 && $moment(transactions[index-1].createdAt).format('YYYY') != $moment(transactions[index].createdAt).format('YYYY')">{{ $moment(transaction.createdAt).format("YYYY") }}</p>
							<div class="transaction-item">
								<div class="row center">
									<div class="transactions-item-date column">
										<p>{{ $moment(transaction.createdAt).format("DD") }}</p>
										<p>{{ $moment(transaction.createdAt).format("MMM") }}</p>
									</div>
									<div class="transaction-item-info column">
										<p class="transaction-item-title">{{ transaction.notes || transaction.statusDesc }}</p>
										<p class="transaction-item-status">{{ $moment(transaction.createdAt).format("HH:mm") }} {{ transaction.statusTitle }}</p>
									</div>
								</div>
								<div class="transaction-item-content">
									<p :class="transactionColor(transaction.type)">{{ transaction.type === 'D' ? "- " : '' }}{{transaction.amount | fmtMoney}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="transactions empty" v-else>
					<img alt="Not Found" src="/static/error/notfound.svg">
					<h4>Nenhuma transação encontrada</h4>
					<p>Envie seus <span v-on:click="$router.push('/links')">links de indicações</span> para seus amigos, nas suas redes sociais e/ou canais que possua para começar a ver suas comissões aparecendo aqui. Ao atingir R$ 20,00 em comissões poderá realizar seu primeiro saque!</p>
				</div>

				<div class="withdraw-list" v-if="withdrawList.length">
					<h4>Saques</h4>
					<div class="transaction-list">
						<div class="transaction-content" v-bind:key="transaction.id" v-for="(transaction, index) in withdrawList">
							<p class="transaction-year" v-if="index > 0 && $moment(transactions[index-1].createdAt).format('YYYY') != $moment(transactions[index].createdAt).format('YYYY')">{{ $moment(transaction.createdAt).format("YYYY") }}</p>
							<div class="transaction-item">
								<div class="row center">
									<div class="transactions-item-date column">
										<p>{{ $moment(transaction.createdAt).format("DD") }}</p>
										<p>{{ $moment(transaction.createdAt).format("MMM") }}</p>
									</div>
									<div class="transaction-item-info column">
										<p class="transaction-item-title">{{ transaction.notes || transaction.statusDesc }}</p>
										<p class="transaction-item-status">{{ $moment(transaction.createdAt).format("HH:mm") }} {{ transaction.statusTitle }}</p>
									</div>
								</div>
								<div class="transaction-item-content">
									<p :class="transactionColor(transaction.type)">{{ transaction.type === 'D' ? "- " : '' }}{{transaction.amount | fmtMoney}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="transactions empty" v-else>
					<img alt="Not Found" src="/static/error/notfound.svg">
					<h4>Nenhum saque realizado!</h4>
					<p>Clique no botão "Sacar" para realizar seu primeiro saque.</p>
				</div>
			</div>
		</div>

		<button class="button see-more" v-if="transactions.length && page < pages - 1" v-on:click="nextPage" :disabled="loadingMore">
			<v-progress-circular v-if="loadingMore" size="24" stroke="2" color="white" indeterminate="indeterminate"></v-progress-circular>
			<p v-else>Ver mais</p>
		</button>
		<v-dialog max-width="500px" v-model="showWithdrawModal" v-if="walletId && email" persistent>
			<WithdrawModal :walletId="walletId" :onClose="closeWithdrawModal" :accounts="accounts"
			:onWithdraw="refreshAccounts" :withdrawTax="withdrawTax" :withdrawMin="withdrawMin"
			:withdrawMinWithTax="withdrawMinWithTax" :maxMonthWithdraw="maxMonthWithdraw"
			:affiliateCompanyType="affiliateCompanyType" :maxWithdraw="maxWithdraw" :email="email"
			/>
		</v-dialog>

		<v-dialog max-width="600px" v-model="showValidationModal" v-if="walletId" persistent>
			<ValidationModal :withdrawMin="withdrawMin" :onClose="closeValidationModal" :userStatusId="userStatusId" :statusNotes="statusNotes" :onValidate="onValidate" />
		</v-dialog>



		<v-dialog
      v-model="showDisclaimerModal"
      persistent
      max-width="500"
    >
      <v-card style="border-radius: 15px; padding: 12px">
        <v-card-title class="text-h5">
          <b style="font-size: 20px;">Atenção!</b>
        </v-card-title>
        <v-card-text style="font-size: 18px;">Os pedidos de saque serão processados e pagos em dias de semana até às 18h. Solicitações feitas aos finais de semana ou feriados serão pagas no próximo dia útil até às 18h. Agradecemos sua compreensão!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
		    style="border-radius: 5px; color: white"
            color="green"
            text
            @click="withdraw"
          >
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	</div>
</template>
<script>
import WithdrawModal from '../components/WithdrawModal.vue';
import ValidationModal from '../components/ValidationModal.vue';
import CodesModal from '../components/CodesModal.vue';
import numeral from 'numeral';
export default {
  components: {
      WithdrawModal,
      ValidationModal,
      CodesModal
    },

  data() {
      return {
          loading: false,
          loadingMore: false,
          walletId: null,
          balance: 0,
          todayBalance: 0,
          showWithdrawModal: false,
          showValidationModal: false,
          showDisclaimerModal: false,
          showCodesModal: false,
          transactions: [],
          withdrawList: [],
          accounts: [],
          userStatusId: 4,
          statusNotes: null,
          page: 0,
          withdrawMin: 0,
          withdrawTax: 0,
          withdrawMinWithTax: 0,
          maxMonthWithdraw: 0,
          affiliateCompanyType: null,
          maxWithdraw: 0,
          email: null,
          mobileNumber: null,

          page: 0,
          pages: 0,
          limit: 100,
      }
    },

  async created() {
      this.loading = true;
      try {

          this.refreshAccounts();
          let myWallets = await this.$api.dataService.execute('wallet/getMyWallets', {});

          //getMinWithdraw
          let auxGetMinWithdraw = await this.$api.dataService.execute('wallet/getMinWithdraw', {});

          this.withdrawMin = auxGetMinWithdraw.withdrawMin;
          this.withdrawTax = auxGetMinWithdraw.withdrawTax;
          this.withdrawMinWithTax = auxGetMinWithdraw.withdrawMinWithTax;

          if (myWallets && myWallets.length) {
              this.walletId = myWallets[0].id;
              //
              let auxGetWalletData = await this.$api.dataService.execute('wallet/getWalletData', { walletId: this.walletId });
              if (auxGetWalletData.balance < 0) auxGetWalletData.balance = 0;
              if (auxGetWalletData.leftToWithdraw < 0) auxGetWalletData.leftToWithdraw = 0;

              this.email = auxGetWalletData.email;
              this.mobileNumber = auxGetWalletData.mobileNumber;
              this.userStatusId = auxGetWalletData.userStatusId;
              this.statusNotes = auxGetWalletData.statusNotes;
              this.maxMonthWithdraw = auxGetWalletData.withdrawMax;
              this.affiliateCompanyType = auxGetWalletData.affiliateCompanyType;
              if (this.affiliateCompanyType) {
                  this.maxWithdraw = auxGetWalletData.balance;
              } else {
                  this.maxWithdraw = auxGetWalletData.balance < auxGetWalletData.leftToWithdraw ? auxGetWalletData.balance : auxGetWalletData.leftToWithdraw;
              }

              let auxBalances = await this.$api.dataService.execute('wallet/getBalance', { walletId: this.walletId });
              if (auxBalances) {
                  this.balance = auxBalances.balance;
                  this.todayBalance = auxBalances.todayBalance;
              }

              let withdrawList = await this.$api.dataService.execute('wallet/getWithdrawList', { walletId: this.walletId, offset: this.page, limit: this.limit });
              this.withdrawList = withdrawList.withdrawList;

              let res = await this.$api.dataService.execute('wallet/getTransactions', { walletId: this.walletId, offset: this.page, limit: this.limit });
              this.transactions = res.transactions;
              this.pages = res.pages;
          } else {
              console.log("ERRO, não achou wallet")
          }
      } catch(err) {
          this.$notifyUser({
              type: 'error',
              message: 'Ocorreu um erro'
          });
      }

      this.loading = false;
    },

  methods: {
      closeWithdrawModal() {
          this.showWithdrawModal = false;
      },

      closeValidationModal() {
          this.showValidationModal = false;
      },

      disclamerWithDraw(){
        this.showDisclaimerModal = true;
      },

      withdraw() {
        this.showDisclaimerModal = false;
          if (this.balance >= this.withdrawMin) {
              if (this.userStatusId == 2) {
                  this.showWithdrawModal = true;
              } else {
                  this.showValidationModal = true;
              }
          } else {
              this.$notifyUser({
                  type: 'error',
                  message: `Você precisa de no mínimo ${numeral(+this.withdrawMin).format('$ 0,0.00')} para sacar!`
              });
          }
      },

      async onValidate(files) {
          const formData = new FormData();
          for(var x = 0; x < files.length; x++){
              if(files[x] && files[x].file && files[x].id){
                  formData.append('documents', files[x].file, files[x].id);
              }
          }
          await this.$api.dataService.postNotJson('affiliateDocs/sendValidationDocuments', formData);
          this.userStatusId = 4;
      },

      removeBankAccount(id) {
          this.$msg.confirm({
              title: 'Remover Conta Bancária',
              message: `Tem certeza que deseja remover essa conta bancária cadastrada?`,
              actions: ['Não', 'Remover Conta'],
              defaultAction: 0
          }).then(async (action) => { 
              if (action === 1) {
                  try {
                      await this.$api.dataService.destroy('bankAccount', id);
                      this.refreshAccounts();

                      this.$notifyUser({
                          message: `Conta removida!`
                      });
                  } catch(e) {
                      // 
                  }
              }
          });
      },

      transactionColor(type) {
          switch (type) {
              case 'D':
                  return 'transaction-item-amount transaction-negative';
              case 'C':
                  return 'transaction-item-amount transaction-positive';
              default:
                  return 'transaction-item-amount transaction-neutral';
          }
      },

      async refreshAccounts() {
          try {
              let res = await this.$api.dataService.execute('bankAccount/getMyBankAccounts', {});
              this.accounts = JSON.parse(JSON.stringify(res));
          } catch(e) {
              // 
          }
      },

      async nextPage() {
          this.loadingMore = true;

          try {
              this.page++;
              let auxTransactions = await this.$api.dataService.execute('wallet/getTransactions', { walletId: this.walletId, offset: this.page, limit: this.limit });
              this.transactions = this.transactions.concat(auxTransactions.transactions);
          } catch(e) {
              // 
          }

          this.loadingMore = false;
      }
    }
};
</script>

<style scoped>
.fa-copy {
	cursor: pointer;
}

p {
	margin: 0;
}

.row {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 5px;
}

.column {
	display: flex;
	flex-direction: column;
}

.center {
	align-items: center;
	justify-content: center;
}

.wallet-container {
	width: 100%;
	height: 100%;
	background-color: var(--background-color);
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: none;
	padding: 40px;
}

/* .wallet-header {
	width: 100%;
	height: 250px;
	background: linear-gradient(to right, var(--primary-color) -100%, var(--primary-color-hover) 150%);
	flex: none;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
} */

.wallet-content {
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 1;
}

.wallet-user {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-bottom: 25px;
	/* background-color: var(--card-color); */
	/* box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.15); */
	/* padding: 25px; */
	border-radius: 20px;
}

.user-wallet-content {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.user-wallet-actions {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-left: 25px;
}

/* .wallet-title {
	margin-top: 125px;
} */

/* .wallet-title h4 {
	font-weight: bold;
} */

.user-wallet-title {
	color: var(--neutral-color);
	font-weight: bold;
}

.user-wallet-type {
	font-size: 20px;
	color: var(--primary-color);
	font-weight: bold;
	line-height: 1;
}

.user-wallet-value {
	color: var(--neutral-color);
	line-height: 1;
}

.user-balance {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: stretch;
}

.user-balance-content h4 {
	font-size: 18px;
	color: var(--neutral-color);
	line-height: 1;
}

.user-balance-content .user-balance-value {
	font-size: 36px;
	font-weight: bold;
	color: var(--black-color);
}

.user-balance-content .user-today-balance-value {
	font-size: 18px;
	color: var(--secondary-color);
	font-weight: bold;
	line-height: 1;
}

.button {
	width: 90px;
	height: 100%;
	border-radius: 20px;
	box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);
	cursor: pointer;
	transition: 0.2s;
	user-select: none;
	font-weight: bold;
	font-size: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
}

.button.user-balance {
	background-color: var(--white-color);
	color: var(--success-color);
}

.button.see-more {
	background-color: var(--primary-color);
	margin-bottom: 50px;
}

.button.user-balance:hover {
	box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
}

.button.user-balance > i {
	font-size: 22px;
	margin-top: 20px;
}

.button.user-balance > p {
	margin-bottom: 10px;
}

.transactions-container {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 20px;
}

.transactions, .withdraw-list {
	width: 100%;
	display: flex;
	flex-direction: column;
	border-radius: 20px;
	margin-top: 25px;
	padding-bottom: 25px;
	color: var(--black-color);
	background-color: var(--card-color);
	margin-bottom: 25px;
}

.transactions {
	flex: 4;
}

.withdraw-list {
	flex: 2;
}

.transactions.empty {
	padding: 50px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.transactions.empty img {
	width: 200px;
}

.transactions.empty h4 {
	color: var(--primary-color);
	font-weight: bold;
	margin-top: 25px;
	font-size: 22px;
}

.transactions.empty p {
	width: 80%;
	margin: 0 auto;
	text-align: center;
	font-size: 14px;
	margin-top: 10px;
}

.transactions.empty p span {
	cursor: pointer;
	color: blue;
	text-decoration: underline;
}

.transactions > h4, .withdraw-list > h4 {
	margin: 25px 0 10px 0;
	font-size: 18px;
	color: var(--neutral-color);
	margin-left: 25px;
	line-height: 1;
}

.transaction-content:nth-child(2n + 2) {
	background-color: #f9f9f9;
}

.transaction-item {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 15px 25px;
}

.transaction-item-amount {
	font-size: 16px;
	white-space: nowrap;
}

.transactions-item-date {
	justify-content: center;
	align-items: center;
	font-weight: bold;
	line-height: 1;
	margin-right: 15px;
}

.transactions-item-date p:first-child {
	font-size: 20px;
	margin-bottom: 3px;
}

.transaction-item-title {
	font-size: 17px;
	color: var(--black-color);
	font-weight: bold;
}

.transaction-item-status {
	font-size: 12px;
	color: var(--neutral-color);
}

.transaction-positive {
	color: #60c232;
	font-weight: bold;
}

.transaction-negative {
	color: #e52727;
	font-weight: bold;
}

.transaction-neutral {
	color: var(--neutral-color);
	font-weight: bold;
}

.transaction-year {
	font-size: 12px;
	color: var(--neutral-color);
	margin: 10px 0 10px 25px;
	padding-top: 10px;
}

.fullscreen-loading {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background-color: #EFEFEF;
	z-index: 2000;
	display: flex;
	justify-content: center;
	align-items: center;
}

.transaction-item-content {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 5px;
}

.fa-info-circle {
	color: var(--primary-color);
}

@media only screen and (max-width: 850px) {
	.wallet-user {
		flex-direction: column;
	}

	.transactions-container {
		flex-direction: column-reverse;
	}
}

@media only screen and (max-width: 450px) {
	.wallet-header {
		height: 210px;
	}

	.wallet-title {
		margin-top: 15px;
		display: none;
	}

	.wallet-user {
		margin-top: 25px;
		margin-bottom: 25px;
		background: none;
		box-shadow: none;
		padding: 0;
	}

	.user-balance {
		width: 100%;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}

	.user-balance-buttons, .user-balance-button {
		width: 100%;
		margin-top: 25px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/Wallet.vue